import t from '~t'
import React from 'react'

import { Link } from 'react-router-dom'
import Screen from '~co/screen/basic'
import { Button, HeaderTitle as Title, Header, Icon } from '~ui';
import Howto from './howto'
import Permissions, { usePermissionsGranted } from './permissions'

export default ()=>{
    const granted = usePermissionsGranted()

	return (
		<Screen>
            <Header data-no-shadow>
                <Button variant='ghost' 
                    as={Link}
                    to='/'
                    title={t.s('back')}>
                    <Icon name='back' />
                </Button>
                <Title>{t.s('addHighlights')}</Title>
            </Header>
            
			{granted ? <Howto /> : <Permissions />}
		</Screen>
	)
}